import { Location } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FeedbackHttpService } from './feedback-http.service';
import { FeedbackRatingComponent } from './feedback-rating/feedback-rating.component';
import {
  FeedbackConfig,
  feedbackFormFields,
  FeedbackRequestBody,
  feedbackRouting,
} from './feedback.model';
import { FeedbackService } from './feedback.service';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'lib-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent implements OnInit {
  @Input() config: FeedbackConfig;
  @Input() url: string;
  @Output() feedbackFormSubmitted = new EventEmitter<FeedbackRequestBody>();
  @Output() isFeedbackOpen = new EventEmitter<boolean>();
  @ViewChild(FeedbackRatingComponent) feedbackRating: FeedbackRatingComponent;

  isFormValid = false;
  feedbackForm: UntypedFormGroup = new UntypedFormGroup({});
  showNextStep = false;
  showFlyout = false;
  feedbackRouteClicked = false;
  currentRating = 0;

  constructor(
    private feedbackService: FeedbackService,
    private feedbackHttpService: FeedbackHttpService,
    private router: Router,
    private location: Location,
  ) {}

  ngOnInit(): void {
    const [config] = checkInputsForText([this.config]);

    this.config = config;
    this.feedbackService.setInititalConfig(this.config);
    this.feedbackRouteClicked = this.router.url.includes(
      feedbackRouting.feedbackURL,
    );
    if (this.feedbackRouteClicked) {
      this.showFlyout = true;
    }
    this.feedbackForm.valueChanges.subscribe(() => {
      this.isFormValid = !!this.feedbackForm.value[feedbackFormFields.comments];
    });
  }

  openFlyout() {
    this.showFlyout = true;
    this.isFeedbackOpen.emit(true);
    this.config = this.feedbackService.getInitialConfig();
  }

  closeFlyout() {
    this.showFlyout = false;
    this.isFeedbackOpen.emit(false);
    this.showNextStep = false;
    this.feedbackForm.reset();

    // resetting icons to empty if closed without submitting
    if (this.feedbackRating) this.feedbackRating.changeIcons(-1);

    if (this.feedbackRouteClicked) {
      this.location.back();
    }
  }

  submitForm() {
    const request = this.buildRequestBody();

    this.feedbackFormSubmitted.emit(request);

    this.feedbackHttpService.postFeedback(this.url, request).subscribe(
      () => {
        this.showNextStep = true;
        this.config = this.feedbackService.updateSuccessHeader(this.config);
      },
      (error) => {
        this.showNextStep = true;
        this.config = this.feedbackService.updateErrorHeader(
          error,
          this.config,
        );
      },
    );
  }

  buildRequestBody() {
    return {
      category: this.feedbackForm.value[feedbackFormFields.category],
      rating: this.currentRating,
      comments: this.feedbackForm.value[feedbackFormFields.comments],
      created_at: this.feedbackService.getDate(),
    };
  }

  ratingUpdated(ratings) {
    this.currentRating = ratings;
  }
}
